<template>
	<v-dialog v-model="invoiceDialog" max-width="800px" transition="scroll-x-reverse-transition">
		<template #activator="{ on, attrs }">
			<v-btn
				color="secondary"
				small
				v-bind="attrs"
				elevation="0"
				v-on="on">
				<v-icon left dark>mdi-email-fast</v-icon>
				Send Invoice
			</v-btn>
		</template>
		<v-card>
			<v-card-title>
				<span class="text-h5">Send Invoice</span>
			</v-card-title>
			<v-card-text>
				<v-container class="mt-3">
					<v-form @submit.prevent="sendInvoice">
						<v-row>
							<v-col>
								<v-text-field v-model="form.recipient_name"
									label="Recipient Name"
									outlined
									persistent-placeholder
									dense
									:error="hasErrors(form, 'recipient_name')"
									:error-messages="errorMsg(form, 'recipient_name')"
									:hide-details="! hasErrors(form, 'recipient_name')"
									required />
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<v-text-field v-model="form.recipient_email"
									label="Recipient Email"
									outlined
									persistent-placeholder
									dense
									:error="hasErrors(form, 'recipient_email')"
									:error-messages="errorMsg(form, 'recipient_email')"
									:hide-details="! hasErrors(form, 'recipient_email')"
									required />
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<v-text-field v-model="form.cc_email"
									label="CC"
									outlined
									persistent-placeholder
									dense
									:error="hasErrors(form, 'cc_email')"
									:error-messages="errorMsg(form, 'cc_email')"
									:hide-details="! hasErrors(form, 'cc_email')" />
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<v-text-field
									v-model="form.subject"
									label="Subject"
									outlined
									persistent-placeholder
									dense
									:error="hasErrors(form, 'subject')"
									:error-messages="errorMsg(form, 'subject')"
									:hide-details="! hasErrors(form, 'subject')"
									required />
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<v-textarea v-model="form.message"
									outlined
									hide-details
									persistent-placeholder
									dense
									placeholder="Additional Message (optional)"
									autofocus></v-textarea>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<fieldset>
									<legend>Message Preview</legend>
									<div class="pa-4">
										<p>Hi {{ form.recipient_name }},</p>
										<p v-if="form.message">{{ form.message }}</p>
										<p>
											Bell Oldow generate an invoice for <strong>JOB #{{ invoice.project.id }} (<em>{{ invoice.project.name }}</em>)</strong>.
											Please click on the link below to view and download.
										</p>
										<div class="text-center">
											<a target="_blank"
												:href="route('public.invoices.show', invoice)"
												class="button button-primary"
												style="box-sizing: border-box; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; position: relative; -webkit-text-size-adjust: none; border-radius: 4px; color: #fff; display: inline-block; overflow: hidden; text-decoration: none; background-color: #2d3748; border-bottom: 8px solid #2d3748; border-left: 18px solid #2d3748; border-right: 18px solid #2d3748; border-top: 8px solid #2d3748;">View Invoice</a>
										</div>
										<p>As always, please call Michael or Andy with any questions at 617-391-0363, or on their mobile numbers.</p>
										<p><em>Best Regards,</em></p>
										<p><em>{{ auth.name }}<br />Bell Oldow, Inc.</em></p>
									</div>
								</fieldset>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<div><strong>Attachment(s):</strong></div>
								<div>
									<a :href="route('public.invoices.download', invoice)"
										target="_blank">
										{{ filename }}
									</a>
								</div>
							</v-col>
						</v-row>
					</v-form>
				</v-container>
			</v-card-text>
			<v-divider />
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
					color="warning darken-1"
					text
					@click="invoiceDialog = false">
					Cancel
				</v-btn>
				<v-btn
					:disabled="clicked"
					color="success"
					:loading="loading"
					@click="sendInvoice">
					Send Invoice
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
export default {
	props: {
		invoice: {
			type: Object,
			default: () => {},
			required: true
		}
	},
	remember: ['form'],
	data () {
		return {
			invoiceDialog: false,
			form: this.$inertia.form({
				recipient_name: this.invoice.project.client.billing_contact_name,
				recipient_email: this.invoice.project.client.billing_contact_email,
				cc_email: '',
				subject: 'Invoice for your Bell Oldow Environmental Project',
				message: ''
			}),
			auth: this.$page.props.auth,
			filename: this.$page.props.filename,
			clicked: false,
			loading: false
		}
	},
	mounted () {
		this.form.reset()
		this.populateForm()
	},
	methods: {
		sendInvoice () {
			this.clicked = true
			this.form.post(this.route('invoices.send', this.invoice), {
				only: ['invoice', 'errors', 'flash'],
				onStart: () => this.loading = true,
				onFinish: () => this.loading = false,
				onSuccess: () => {
					this.invoiceDialog = false
					this.clicked = false
					this.form.reset()
				},
				onError: () => {
					this.clicked = false
				}
			})
		},
		populateForm () {
			this.form.recipient_name = this.invoice.project.client.billing_contact_name
			this.form.recipient_email = this.invoice.project.client.billing_contact_email
		}
	}
}
</script>
